import getMapData from './_getMapData.js';

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

export default mapCacheHas;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_mapCacheHas.js
// module id = 1477
// module chunks = 1